var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.5 22.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.5A1.5,1.5,0,0,1,1.5,0L37,.11a1.5,1.5,0,0,1,0,3L1.5,3A1.5,1.5,0,0,1,0,1.5ZM1.5,9.55H37a1.5,1.5,0,0,0,0-3H1.5a1.5,1.5,0,0,0,0,3ZM37,13.05H1.5a1.5,1.5,0,0,0,0,3H37a1.5,1.5,0,0,0,0-3Zm0,6.5H17.88a1.5,1.5,0,0,0,0,3H37a1.5,1.5,0,0,0,0-3Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.eedc0eb13f64199f3b4199fb30c5dde9.svg";
export { ForwardRef as ReactComponent };